import './flex.css';
import './cimpress-colors.css';
import './index.css';
import 'react-json-inspector/json-inspector.css';
import React from 'react';
import { render } from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import errorHandler from './utils/error-handler';
import { LoggingProvider } from './contexts/logging-provider';
import { BrowserRouter } from 'react-router-dom';
import { createReduxStore } from './store';
import { ShipmentsServiceProvider } from './contexts/shipments-service';
import { WorkflowsServiceProvider } from './contexts/workflows-service';

const { store, appServices } = createReduxStore();

window.addEventListener('error', errorHandler(appServices.loggingService));

render(
  <BrowserRouter>
    <LoggingProvider service={appServices.loggingService}>
      <WorkflowsServiceProvider service={appServices.workflowsService}>
        <ShipmentsServiceProvider service={appServices.shipmentsService}>
          <Provider store={store}>
            <App />
          </Provider>
        </ShipmentsServiceProvider>
      </WorkflowsServiceProvider>
    </LoggingProvider>
  </BrowserRouter>,
  document.getElementById('root'),
);
